// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_B2xxs","inner":"index_inner_3Pejb","text":"index_text_1JtUh","btn":"index_btn_2hEPD"};